(ns hai.web-app.window
  (:require
   [hai.ui.rf-sugar :refer [>e >e! defeffect defevent defevent-fx defsub]]))

(defsub :window/width [db]
  (:window/width db))

(defsub :window/height [db]
  (:window/height db))

(defevent :window/update-size [db width height]
  (assoc db :window/width width :window/height height))

(defeffect :window/listen-size [_]
  (let [set-size (fn []
                   (let [width (.-innerWidth js/window)
                         height (.-innerHeight js/window)]
                     (>e [:window/update-size width height])))]
    (set-size)
    (.addEventListener js/window "resize" set-size)))

(defevent-fx :window/initialize [_ _]
  {:window/listen-size true})

(defn init! []
  (>e! [:window/initialize]))
